.overlay {
  position: fixed;
  inset: 0;
  background-color: var(--tuna-palette-backdrop);
  z-index: 1200;
}

.drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: auto;
  max-width: 500px;
  background-color: var(--tuna-palette-background-paper);
  z-index: 1300;
  box-shadow: -4px 0 16px color-mix(in oklch, var(--tuna-shadow-color) 20%, transparent);
  overflow: auto;
}

.drawerContent {
  padding: 8px;
}

.closeButton {
  position: absolute;
  right: 8px;
  z-index: 1;
}
